import type { SurveyRecord, InterviewRecord } from '@bandos/shared'
import type { ResearchItem } from './types'

const SURVEY_SECONDS: Record<string, number> = {
  open: 90,
  scale: 15,
  yes_no: 10,
  multiple_choice: 20,
  checkbox: 25,
}

const INTERVIEW_SECONDS_PER_QUESTION = 180

export function surveyToItem(record: SurveyRecord): ResearchItem {
  const totalSeconds = record.questions.reduce((sum, q) => sum + (SURVEY_SECONDS[q.type] ?? 30), 0)
  return {
    id: record.id,
    type: 'survey',
    label: record.label,
    description: record.description,
    parentLabel: record.parentLabel,
    questionCount: record.questions.length,
    estimatedMinutes: Math.max(1, Math.round(totalSeconds / 60)),
    respondentCount: record.respondentCount,
    createdAt: record.createdAt,
    status: record.status,
    closedAt: record.closedAt,
  }
}

export function interviewToItem(record: InterviewRecord): ResearchItem {
  const totalSeconds = record.questions.length * INTERVIEW_SECONDS_PER_QUESTION
  return {
    id: record.id,
    type: 'interview',
    label: record.label,
    description: record.description,
    parentLabel: record.parentLabel,
    questionCount: record.questions.length,
    estimatedMinutes: Math.max(1, Math.round(totalSeconds / 60)),
    respondentCount: record.respondentCount,
    createdAt: record.createdAt,
    status: null,
    closedAt: null,
  }
}
